import { contentApi } from '@/lib/api'

export interface LibraryDocument {
  id: string
  title: string
  slug: string
  summary: string | null
  document_type: string
  author_name: string | null
  source: string | null
  publication_year: number | null
  cover_image_url: string | null
  page_count: number
  original_filename: string | null
  status: 'draft' | 'published'
  featured: boolean
  view_count: number
  created_at: string
  updated_at: string
  published_at: string | null
  taxonomies?: Array<{
    id: string
    name: string
    slug: string
    type: string
  }>
}

export interface ListLibraryParams {
  page?: number
  limit?: number
  search?: string
  taxonomy_ids?: string
  document_types?: string
  featured?: string
}

export interface ListLibraryResponse {
  data: LibraryDocument[]
  pagination: {
    page: number
    limit: number
    total: number
    total_pages: number
  }
}

export interface LibraryTaxonomies {
  categories: Array<{ id: string; name: string; slug: string; type: string; description: string }>
  tags: Array<{ id: string; name: string; slug: string; type: string; description: string }>
}

export const libraryService = {
  async listDocuments(params?: ListLibraryParams): Promise<ListLibraryResponse> {
    const response = await contentApi.get('/content/library/documents', { params })
    return response.data
  },

  async getDocumentBySlug(slug: string): Promise<LibraryDocument> {
    const response = await contentApi.get(`/content/library/documents/${slug}`)
    return response.data
  },

  getPdfUrl(docId: string): string {
    const baseUrl = contentApi.defaults.baseURL || ''
    return `${baseUrl}/content/library/documents/${docId}/pdf`
  },

  async fetchPdfBlob(docId: string): Promise<ArrayBuffer> {
    const response = await contentApi.get(`/content/library/documents/${docId}/pdf`, {
      responseType: 'arraybuffer',
    })
    return response.data
  },

  async downloadDocument(docId: string, filename: string): Promise<void> {
    const response = await contentApi.get(`/content/library/documents/${docId}/download`, {
      responseType: 'blob',
    })
    const url = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(url)
  },

  async incrementView(id: string): Promise<void> {
    await contentApi.post(`/content/library/documents/${id}/view`)
  },

  async getTaxonomies(): Promise<LibraryTaxonomies> {
    const response = await contentApi.get('/content/library/taxonomies')
    return response.data
  },
}
